module.exports = __webpack_public_path__ + "img/loginBg.0e52dd4d.png";